import H2 from "../../../../src/components/post-components/H2";
import * as React from 'react';
export default {
  H2,
  React
};